export default __webpack_public_path__ + "static/media/LashLash.6ddb2205.png";